// extracted by mini-css-extract-plugin
export var bubble = "_22-0";
export var container = "_22-f";
export var contrastBorder = "_22-g";
export var greyOut = "_22-2";
export var initialsColor0 = "_22-3";
export var initialsColor1 = "_22-4";
export var initialsColor10 = "_22-d";
export var initialsColor11 = "_22-e";
export var initialsColor2 = "_22-5";
export var initialsColor3 = "_22-6";
export var initialsColor4 = "_22-7";
export var initialsColor5 = "_22-8";
export var initialsColor6 = "_22-9";
export var initialsColor7 = "_22-a";
export var initialsColor8 = "_22-b";
export var initialsColor9 = "_22-c";
export var initialsWrapper = "_22-1";
export var large = "_22-l";
export var medium = "_22-k";
export var mediumSmall = "_22-j";
export var mediumSmallMedium = "_22-o";
export var micro = "_22-h";
export var small = "_22-i";
export var tiny = "_22-n";
export var xTiny = "_22-m";